export const getPalencaConnectUrl = (externalId: string): string => {
	const widgetId = process.env.REACT_APP_PALENCA_WIDGET_ID;
	const isSandbox = process.env.REACT_APP_PALENCA_IS_SANDBOX;

	return `${process.env.REACT_APP_PALENCA_CONNECT_URL}?widget_id=${widgetId}&is_sandbox=${isSandbox}&external_id=${externalId}`;
};
